/* eslint-disable react/prop-types */
import React, { memo, useEffect, useState } from "react";
import { Box, Switch, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import DatePicker from "react-flatpickr";
import SoftDatePicker from "components/SoftDatePicker";
import { Vietnamese } from "flatpickr/dist/l10n/vn";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  minWidth: 100,
};

const selectStyle = {
  minWidth: 100,
  fontSize: 13,
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
};

const Td = ({ children, style, ...rest }) => {
  return (
    <td {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </td>
  );
};

function TaxPersonalTable02({ setFieldValue }) {
  const [data, setData] = useState([
    {
      id: uuidV4(),
      value22: "",
      value23: "",
      value24: "",
      value25: "",
      value26: "",
      value27: "",
      value28: "",
      value29: "",
      value30: "",
      value31: "",
      value32: "",
      value33: "",
      value34: "",
    },
  ]);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { name, value, id } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  const handleChangeValue = (id, name, value) => {
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  const handleAdd = () => {
    const newRow = {
      id: uuidV4(),
      value22: "",
      value23: "",
      value24: "",
      value25: "",
      value26: "",
      value27: "",
      value28: "",
      value29: "",
      value30: "",
      value31: "",
      value32: "",
      value33: "",
      value34: "",
    };
    setData((prev) => [...prev, newRow]);
  };

  const handleDelete = (id) => {
    setData((prev) => prev.filter((item) => item.id !== id));
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Typography variant="h5">II. Người phụ thuộc đăng ký thuế bằng giấy khai sinh:</Typography>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td
                className="toggle-button"
                rowSpan={3}
                style={{ textAlign: "center", fontWeight: "bold", minWidth: 0 }}
              >
                STT
                <div className="button-action">
                  <button type="button" onClick={handleAdd}>
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td rowSpan={3} style={{ textAlign: "center", fontWeight: "bold" }}>
                Họ và tên
              </Td>
              <Td rowSpan={3} style={{ textAlign: "center", fontWeight: "bold" }}>
                MST (ghi trong trường hợp thay đổi thông tin)
              </Td>
              <Td rowSpan={1} colSpan={7} style={{ textAlign: "center", fontWeight: "bold" }}>
                Thông tin trên giấy khai sinh
              </Td>
              <Td rowSpan={3} style={{ textAlign: "center", fontWeight: "bold" }}>
                Quốc tịch
              </Td>
              <Td rowSpan={3} style={{ textAlign: "center", fontWeight: "bold" }}>
                Quan hệ với cá nhân có thu nhập được giảm trừ gia cảnh
              </Td>
              <Td rowSpan={3} style={{ textAlign: "center", fontWeight: "bold" }}>
                Tên cá nhân có thu nhập
              </Td>
              <Td rowSpan={3} style={{ textAlign: "center", fontWeight: "bold" }}>
                Mã số thuế của cá nhân có thu nhập
              </Td>
            </tr>
            <tr>
              <Td rowSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                Ngày sinh
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                Số
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                Ngày cấp
              </Td>
              <Td rowSpan={1} colSpan={4} style={{ textAlign: "center", fontWeight: "bold" }}>
                Nơi đăng ký
              </Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Quốc gia</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Tỉnh/ thành phố</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Quận/ Huyện</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Phường/Xã</Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center", fontWeight: "bold", minWidth: 0 }}>(21)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(22)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(23)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(24)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(25)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(26)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(27)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(28)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(29)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(30)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(31)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(32)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(33)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(34)</Td>
            </tr>

            {data.map((item, index) => (
              <tr key={item.id}>
                <Td
                  className="toggle-button"
                  style={{ textAlign: "center", fontWeight: "bold", minWidth: 0 }}
                >
                  {index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete(item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    id={item.id}
                    type="text"
                    name="value22"
                    value={item.value22}
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    id={item.id}
                    type="text"
                    name="value23"
                    value={item.value23}
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <DatePicker
                    style={selectStyle}
                    options={{
                      locale: Vietnamese,
                      time_24hr: true,
                      dateFormat: "d-m-Y",
                    }}
                    name="value24"
                    onChange={(e) => handleChangeValue(item.id, "value24", e[0])}
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    id={item.id}
                    name="value25"
                    value={item.value25}
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <DatePicker
                    style={selectStyle}
                    options={{
                      locale: Vietnamese,
                      time_24hr: true,
                      dateFormat: "d-m-Y",
                    }}
                    name="value26"
                    onChange={(e) => handleChangeValue(item.id, "value26", e[0])}
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeValue(item.id, "value27", e.target.value)}
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeValue(item.id, "value28", e.target.value)}
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeValue(item.id, "value29", e.target.value)}
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeValue(item.id, "value30", e.target.value)}
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeValue(item.id, "value31", e.target.value)}
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeValue(item.id, "value32", e.target.value)}
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    id={item.id}
                    name="value33"
                    type="text"
                    value={item.value33}
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    id={item.id}
                    name="value34"
                    type="text"
                    value={item.value34}
                    onChange={handleChange}
                  />
                </Td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

export default memo(TaxPersonalTable02);

function InputTable(props) {
  const { onChange, type, name, id, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (type === "text") {
      onChange({ value, name, type, id });
    }
    console.log(type);
    if (!type || type !== "text") {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ value: newValue !== "" ? +newValue : "", name, type, id });
    }
  }
  return (
    <input
      type="text"
      name={name}
      style={{
        textAlign: type === "text" ? "left" : "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.2rem 0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
